import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=1ce8d2b4&scoped=true&"
import script from "./FooterInfo.vue?vue&type=script&lang=ts&"
export * from "./FooterInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=1ce8d2b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8d2b4",
  null
  
)

export default component.exports